import theme, { scrollbarStyles } from "./theme";

export const dialogStyles = {
  // added on paper props of dialog
  dialogRoot: {
    borderRadius: theme.borderRadius.lg,
    backgroundColor: theme.backgroundColors.dark.blackVariants.primary,
  },

  // added on dialogtitle component
  dialogTitle: {
    fontWeight: theme.typography.fontWeight.bold,
    backgroundColor: theme.backgroundColors.dark.blackVariants.secondary,
    color: theme.textColors.dark.primary,
    padding: "8px 12px",
    textAlign: "center",
    position: "relative",
    borderTopLeftRadius: theme.borderRadius.lg,
    borderTopRightRadius: theme.borderRadius.lg,
  },

  // icon style of close if it exists in dialog title
  dialogCloseIcon: {
    position: "absolute",
    right: 12,
    top: 4,
    color: theme.textColors.dark.disabled,
    cursor: "pointer",
    transition: "color 0.2s",
    "&:hover": {
      color: theme.textColors.dark.primary,
    },
  },

  // added on dialogtitletext component
  dialogTitleText: {
    fontSize: theme.typography.fontSize.md,
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.textColors.dark.primary,
  },

  // added on dialogContentText component
  dialogContentText: { color: theme.textColors.dark.primary, mb: 1 },

  // added on dialogContent component
  dialogContent: {
    backgroundColor: theme.backgroundColors.dark.blackVariants.primary,
    padding: "24px",
    color: theme.textColors.dark.primary,
    overflowY: "auto",
    ...scrollbarStyles,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  // used to create sections within the dialog content - doesnt contain section header
  paperSection: {
    padding: "16px",
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.backgroundColors.dark.blackVariants.secondary,
    maxHeight: 200,
    overflowY: "auto",
    border: `1px solid ${theme.border.divider}`,
    color: theme.textColors.dark.primary,
  },

  // section header for above paper section in dialog
  sectionHeader: {
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: theme.typography.fontSize.md,
    color: theme.textColors.dark.primary,
  },

  // styles for dialog actions component
  dialogActions: {
    padding: "12px",
    backgroundColor: theme.backgroundColors.dark.blackVariants.secondary,
    border: `1px solid ${theme.border.divider}`,
    color: theme.textColors.dark.primary,
  },
};
